import Filter from "sap/ui/model/Filter";
import Context from "sap/ui/model/odata/v4/Context";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";

export default class ODataModelUtils {
    public static async requestProperty(model: ODataModel, path: string): Promise<unknown> {
        const propertyBinding = model.bindProperty(path);
        return await propertyBinding.requestValue();
    }

    public static async requestObject(model: ODataModel, path: string): Promise<Record<string, unknown>> {
        const contextBinding = model.bindContext(path);
        return await contextBinding.requestObject() as Record<string, unknown>;
    }

    public static async setValue(model: ODataModel, path: string, field: string, value: string) {
        const context = model.bindContext(path).getBoundContext();
        if (!context) {
            throw new Error(`Context for path ${path} not found.`);
        }
        const propertyBinding = model.bindProperty(field, context);
        await propertyBinding.requestValue(); // Ensure the binding is initialized
        if (!propertyBinding.isResolved()) {
            throw new Error(`Property binding for field ${field} is not resolved.`);
        }
        propertyBinding.setValue(value, 'defaultUpdateGroup');
        try {
            await model.submitBatch('defaultUpdateGroup');
        } catch (error) {
            console.error(`Failed to set value for ${field} at ${path}:`, error);
            throw error;
        }
    }

    public static async getFirstMatch(model: ODataModel, path: string, filter: Filter, params? : {
        $expand?: string | string[];
        $select?: string | string[];
        $orderby?: string;
    }): Promise<Record<string, unknown> | null> {
        const listBinding = model.bindList(path, undefined, undefined, [filter], params);
        const contexts = await listBinding.requestContexts(0, 1);
        const context = contexts.length > 0 ? contexts[0] : null;
        if (!context) {
            return null;
        }
        const data = await context.requestObject() as Record<string, unknown>;
        return data;

    }

    public static createEntity(model: ODataModel, path: string, data: Record<string, unknown>): Context {
        const context = model.bindList(path, null, null, null, {'$$updateGroupId': 'defaultUpdateGroup'}).create(data);
        return context;
    }
}